export class AcuseRecibo {
   id: string;
   emisorId: string;
   response: number;
   description: string;
   rejectionType: number;
   usuarioId: string;
   acuseRevisionDte: boolean;
   acuseReciboMercaderias: boolean;
}
